module.exports = __webpack_public_path__ + "img/ricelog_pinicon_081.6552d137.png";